var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKsLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 231,
    viewBox: "0 0 362 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.254 55.3521C281.089 55.3521 275.188 57.8028 270.828 62.1641L202.862 130.152C198.33 134.684 198.33 142.05 202.862 146.582L252.309 196.045C256.708 200.445 262.688 202.896 268.919 202.843L335.963 202.33C341.087 202.29 343.656 196.097 340.06 192.448L294.933 146.582C290.455 142.036 290.494 134.724 294.999 130.218L359.923 65.2736C363.585 61.6106 360.99 55.3521 355.813 55.3521H287.254ZM70.3657 0.0131888C65.1891 0.0131888 62.5943 6.27175 66.2561 9.93466L131.101 74.7998C135.632 79.3323 135.632 86.6976 131.101 91.2301L1.71386 220.67C-1.94792 224.333 0.646933 230.592 5.82348 230.592H74.3832C80.5476 230.592 86.4486 228.141 90.8084 223.78L223.318 91.2301C227.849 86.6976 227.849 79.3323 223.318 74.7998L155.351 6.81197C150.991 2.45074 145.09 0 138.925 0H70.3657V0.0131888Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsLogoNew);
export default __webpack_public_path__ + "static/media/ks-logo-new.808a074c5b4bcefe61b8cd9e17d15e68.svg";
export { ForwardRef as ReactComponent };